import styled from 'styled-components';

/** Matches the plain cells around it, so an editable column does not read as a form. */
export const CellButton = styled.button`
  width: 100%;
  border: none;
  background: none;
  padding: 2px 4px;
  font: inherit;
  color: inherit;
  text-align: center;
  cursor: text;
  border-radius: 4px;

  &:hover {
    background: rgba(125, 125, 125, 0.12);
  }

  &:focus-visible {
    outline: 2px solid #1677ff;
    outline-offset: -2px;
  }
`;

export const CellText = styled.span<{ $muted?: boolean }>`
  display: block;
  text-align: center;
  opacity: ${({ $muted }) => ($muted ? 0.55 : 1)};
`;

export const EditingCell = styled.div`
  min-width: 90px;
`;
